module.exports = __webpack_public_path__ + "static/media/beadslogo.77f5a0a8.jpg";